export default __webpack_public_path__ + "static/media/Gallery-18.3b7e5eb2.jpeg";